import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.mainDirection = ''
      this.venueName = ''
    }
  }
}
export default searchFrom
